import clsx from 'clsx';

import Button from '@/components/Button/Button';
import type {TipsInstruction} from '@/services/content/tipsContent.types';

type InstructionContentProps = {
    step: TipsInstruction;
    hasMultipleSlides: boolean;
    onPrimaryButtonClick: (action?: string, trackingValue?: string) => void;
    overlapsMedia?: boolean;
};

const InstructionContent = ({
    step,
    hasMultipleSlides,
    onPrimaryButtonClick,
    overlapsMedia = true,
}: InstructionContentProps) => {
    const {title, description, primaryButton} = step;
    const {
        text: buttonText,
        alt: buttonAlt,
        action: buttonAction,
        trackingValue: buttonTrackingValue,
    } = primaryButton ?? {};

    return (
        <div
            className={clsx(
                'w-full px-6 pt-8 text-left',
                overlapsMedia && 'backdrop-blur-[2px]',
                hasMultipleSlides ? 'pb-[70px]' : 'pb-8'
            )}
        >
            <h2 className='wrap-break-word mb-4 font-bold text-2xl'>{title}</h2>
            <p
                className='wrap-break-word mb-0 text-base leading-relaxed'
                dangerouslySetInnerHTML={{__html: description ?? ''}}
            />
            {buttonText && (
                <Button
                    className='mt-8'
                    aria-label={buttonAlt || buttonText}
                    onClick={() => onPrimaryButtonClick(buttonAction, buttonTrackingValue)}
                >
                    {buttonText}
                </Button>
            )}
        </div>
    );
};

export default InstructionContent;
